// extracted by mini-css-extract-plugin
module.exports = {"headline":"CollectionRankingInfoDialog_headline__3TvJX","text":"CollectionRankingInfoDialog_text__2DMnS","button":"CollectionRankingInfoDialog_button__k_IcJ"};